module.exports = __webpack_public_path__ + "img/Users.6afbdb5b.svg";